
define('text!modules/graphs/directives/timeline-bar-chart/template.html',[],function () { return '<div class=c-timelineBarChart></div>';});

